
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/viagens/crie-seu-roteiro",
      function () {
        return require("private-next-pages/viagens/crie-seu-roteiro.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/viagens/crie-seu-roteiro"])
      });
    }
  